import store from '@/store/index'

async function isAuthenticated(to, from, next) {

  if (store.getters.isAuthenticated && store.getters.verifyEmail === false && to.name !== 'VerificaEmail') {
    if (to.name === 'VerificaEmailHash') {
      return next()
    } else {
      if (to.path != from.path)
        return next(`/verificar-email${window.location.search}`)
    }
  }

  let userPermissions = []
  if (store.getters.isAuthenticated && store.getters.getAllPermissionsNames && store.getters.getAllPermissionsNames.length) {
    userPermissions = await store.getters.getAllPermissionsNames;
  } else if (store.getters.isAuthenticated) {
    await store.dispatch("actionPermissions");
    userPermissions = await store.getters.getAllPermissionsNames;
  }

  if (store.getters.isAuthenticated) {
    store.dispatch("userRequest").catch(() => { });
  }

  const requiredPermissions = await to.meta.permissionName || null;
  const hasPermission = await userPermissions.includes(requiredPermissions);

  if (store.getters.isAuthenticated && (hasPermission || requiredPermissions === null)) {
    return next();
  } else if (store.getters.isAuthenticated && !hasPermission) {
    // Tenta redirecionar para a primeira rota que o usuário tem permissão.
    // Se não encontrar nenhuma rota conhecida (ex: usuário Client-only cujas
    // permissões não mapeiam para rotas de seller), redireciona para a rota
    // padrão do comprador. Sem esse fallback, next('/') causaria loop infinito
    // pois '/' redireciona de volta para '/dashboard', que exige permissão 'Dashboard'.
    const firstKnownRoute = routes[userPermissions[0]];
    const fallbackRoute = clientRoutes[userPermissions[0]] || clientFallback;
    return next('/' + (firstKnownRoute || fallbackRoute));
  }

  return next('/')
}

const authentication = isAuthenticated

// Rotas de seller — mapeadas por nome de permissão
const routes = {
  Dashboard: 'dashboard',
  Sales: 'vendas',
  Contracts: 'contratos',
  Commissions: 'comissoes',
  Products: 'produtos',
  Notes: 'central-de-notas',
  Links: 'links',
  Checkouts: 'checkouts',
  Reports: 'relatorios',
  Statements: 'extrato',
  Coupons: 'cupom',
  Leads: 'gestao-leads',
  Claims: 'reclamacoes',
  Integrations: 'integracoes',
  Showcase: 'vitrine',
  Recruitment: 'recrutamento',
}

// Rotas de comprador (role Client) — mapeadas por nome de permissão
const clientRoutes = {
  Purchase: 'compras',
}

// Rota de fallback para usuários autenticados sem nenhuma permissão mapeada em
// routes nem em clientRoutes. Evita o loop: next('/') → /dashboard → sem permissão
// → next('/') → stack overflow. Cobre Client-only (sem beta MY_PURCHASES) e também
// qualquer permissão de seller não registrada em routes.
// ATENÇÃO: ao adicionar novas permissões de seller, registre-as em routes acima.
const clientFallback = 'compras'

export default authentication